module.exports = __webpack_public_path__ + "static/media/lautaro_martinez.7871dab3.jpg";